import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Observable, Subscription } from "rxjs";
import { DatosCreacionBhe } from "src/app/models/BoletaHonorarios/DatosCreacionBhe";
import { DetalleBoletaHonorarios } from "src/app/models/BoletaHonorarios/DetalleBoletaHonorarios";
import { ResumenDetallesBhe } from "src/app/models/BoletaHonorarios/ResumenDetallesBhe";
import { EmisionBheService } from "src/app/services/emision-bhe.service";
import { environment } from "src/environments/environment";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';
import { Servicio } from "src/app/models/Servicio/Servicio";
import { Page } from "src/app/shared/models/Page";
import { ServicioFilter } from "src/app/models/Servicio/ServicioFilter";
import { SelectionType } from "@swimlane/ngx-datatable";
import { Subject } from "@microsoft/signalr";
import { ServicioService } from "src/app/services/servicios.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilitiesService } from "src/app/services/utilities.service";
import Swal from "sweetalert2";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
@Component({
	selector: "app-prestaciones-bhe",
	templateUrl: "./prestaciones-bhe.component.html",
	styleUrls: ["./prestaciones-bhe.component.scss"],
})
export class PrestacionesBheComponent implements OnInit {
	public prestacionesForm: FormGroup;
	public prestacionesArray: FormArray;
	private detallesBhe: DetalleBoletaHonorarios[] = [];
	private resumenBhe: ResumenDetallesBhe = new ResumenDetallesBhe();
	@Output() public prestacionesEmitter: EventEmitter<any> = new EventEmitter<any>();
	public totalBruto: number = 0;
	public montoRetencion: number = 0;
	public liquido: number = 0;
	private datosReceptor$: Observable<DatosCreacionBhe>;
	private currentBheDatos: DatosCreacionBhe;
	private subs: Subscription[] = [];
	public porcentajeRetencion: number; // Variable para guardar el porcentaje de retención.
	public buscadorServicioForm: FormGroup;
	public serviceSearchCatalog: Servicio[] = [];
	public serviceSearchLoading: boolean = false;

	public serviceRows: Servicio[] = [];
	public pageServices = new Page();
	private serviceFilter = new ServicioFilter();
	public SelectionType = SelectionType;
	private serviceListModalRef: any;
	private searchServiceSubject = new Subject<{ term: string; propertyName: string }>();
	private currentEmisorId: string;
	private sucursalId: string;
	public loadingServices: boolean = false;
	public selectedService: Servicio | null = null;
	constructor(private formBuilder: FormBuilder, private emisionBheService: EmisionBheService,private sessionUserService: SessionUserService,
		private servicioService: ServicioService,
  		private tokenService: TokenStorageService,
		private modalService: NgbModal,
		private utilities: UtilitiesService
	) {
		this.setPrestacionesArray();
		this.datosReceptor$ = this.emisionBheService.datosReceptorObservable;
	}

	ngOnInit(): void {
		this.currentEmisorId = this.tokenService.getCompany();
  		this.sucursalId = this.tokenService.getSubsidiary();
		this.sessionUserService.verificarSesionUsuario();
		this.porcentajeRetencion = this.getTaxesBhe(2023);
		this.initBuscadorServicioForm();
		const sub = this.datosReceptor$.subscribe((datos) => {
			this.currentBheDatos = datos;
			this.onSubmit();
		});
		this.subs.push(sub);
	}

	setPrestacionesArray() {
		this.prestacionesForm = this.formBuilder.group({
			prestaciones: this.formBuilder.array([this.newPrestacionForm()]),
		});
	}
	newPrestacionForm(): FormGroup {
		return this.formBuilder.group({
			descripcion: [, Validators.required],
			valor: [, Validators.required],
		});
	}
	addPrestacionForm() {
		const currentArray = this.getArray();
		if (currentArray.length < 10) {
			let newPrestacionForm = this.newPrestacionForm();
			currentArray.push(newPrestacionForm);
		}
	}

	removePrestacion(index: number) {
		const currentArray = this.getArray();
		if (currentArray.length > 1) {
			currentArray.removeAt(index);
		} else {
			currentArray.reset();
		}
		this.onSubmit();
	}

	onSubmit() {
		if (this.prestacionesForm.valid) {
			this.detallesBhe = this.processArrayToDetalles();
			if (this.detallesBhe && this.detallesBhe.length > 0) {
				this.getTotal();
				this.prestacionesEmitter.emit(this.detallesBhe);
				this.emisionBheService.setDetallesResumen(this.resumenBhe);
			}
		}
	}

	processArrayToDetalles(): DetalleBoletaHonorarios[] {
		let currentArray = this.getArray();
		let detallesList: DetalleBoletaHonorarios[] = [];
		if (currentArray.length > 0) {
			currentArray.controls.forEach((prestacionForm, index) => {
				let detalle = new DetalleBoletaHonorarios();
				if (prestacionForm.valid) {
					detalle.descripcion = (prestacionForm as FormGroup).controls.descripcion.value;
					detalle.valor = (prestacionForm as FormGroup).controls.valor.value;
					detallesList.push(detalle);
				}
			});
			return detallesList;
		}
		return null;
	}

	getTaxesBhe(yearOfStart: number): number {
		const currentYear = new Date().getFullYear();
		const index = currentYear - yearOfStart;

		if (index >= 0 && index < environment.withholdBheValues.length) {
			return environment.withholdBheValues[index];
		} else {
			return 0;
		}
	}

	getTotal() {
		this.totalBruto = this.detallesBhe.reduce((suma, detalle) => (suma += +detalle.valor), 0);

		let retencion = Math.round(this.totalBruto * this.porcentajeRetencion);
		if (this.currentBheDatos.retencionEmisor) {
			this.montoRetencion = 0;
		} else {
			this.montoRetencion = retencion;
		}
		this.liquido = Math.round(this.totalBruto - this.montoRetencion);
		this.resumenBhe.detalles = this.detallesBhe;
		this.resumenBhe.bruto = this.totalBruto;
		this.resumenBhe.total = this.totalBruto;
		this.resumenBhe.retenido = retencion;
		this.resumenBhe.montoRetencion = retencion;
		this.resumenBhe.liquido = this.liquido;
	}

	getArray(): FormArray {
		return this.prestacionesForm.controls.prestaciones as FormArray;
	}
	private initBuscadorServicioForm(): void {
		this.buscadorServicioForm = this.formBuilder.group({
			servicio: [],
		});
	}
	searchService(event: any, propertyName: string): void {
		this.searchServiceSubject.next({ term: event.term, propertyName });
	}

	clearServiceSearch(): void {
		this.buscadorServicioForm.get('servicio')?.patchValue(null);
		this.serviceSearchCatalog = [];
	}

	onServiceSelectedFromSearch(servicio: Servicio): void {
		if (!servicio) {
			return;
		}
		this.buscadorServicioForm.get('servicio')?.patchValue(servicio);
		this.addPrestacionFromService(servicio);
	}
	private addPrestacionFromService(servicio: Servicio): void {
		const array = this.getArray();

		let targetIndex = array.controls.findIndex((ctrl) => {
			const g = ctrl as FormGroup;
			const desc = g.get('descripcion')?.value;
			const val = g.get('valor')?.value;
			return (!desc || desc === '') && (val == null || val === '');
		});

		let targetGroup: FormGroup;

		if (targetIndex >= 0) {
			targetGroup = array.at(targetIndex) as FormGroup;
		} else {
			if (array.length >= 10) {
			Swal.fire({
				icon: 'warning',
				title: 'Límite de prestaciones',
				text: 'No es posible agregar más prestaciones (máximo 10).',
			});
			return;
			}
			targetGroup = this.newPrestacionForm();
			array.push(targetGroup);
		}

		targetGroup.patchValue({
			descripcion: servicio.nombre,
			valor: servicio.precio,
		});

		this.onSubmit();
	}
	openServiceListModal(modalRef: any): void {
		this.serviceFilter = new ServicioFilter();
		this.serviceFilter.emisorId = this.currentEmisorId;
		this.serviceFilter.sucursalId = this.sucursalId;

		this.setPageServices({ offset: 0 });

		this.serviceListModalRef = this.modalService.open(modalRef, {
			windowClass: '',
			size: 'xl',
		});
	}

	setPageServices(pageInfo: any): void {
		this.loadingServices = true;

		this.pageServices.pageNumber = pageInfo.offset;
		this.pageServices.pageNumber += 1;

		this.servicioService
			.getDataByPage(this.serviceFilter, this.pageServices)
			.subscribe(
			(pagedData: PagedResponse<Servicio>) => {
				this.serviceRows = pagedData.data as Servicio[];
				this.setPageFromServiceResponse(this.pageServices, pagedData);
				this.loadingServices = false;
			},
			(error) => {
				this.loadingServices = false;
				Swal.fire({
				icon: 'error',
				title: 'Error en la solicitud',
				text: this.utilities.setErrorMessageFromArray(error.error),
				});
			}
			);
	}

	setPageFromServiceResponse(currentPage: Page, data: PagedResponse<Servicio>): void {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}
	public agregarServicioSeleccionado(): void {
		const servicio = this.buscadorServicioForm.get('servicio')?.value as Servicio;
		if (!servicio) {
			Swal.fire({
			icon: 'warning',
			title: 'Sin servicio seleccionado',
			text: 'Debe seleccionar un servicio antes de agregarlo.',
			});
			return;
		}

		this.addPrestacionFromService(servicio);

		this.buscadorServicioForm.get('servicio')?.reset();
		this.serviceSearchCatalog = [];
	}
	onActivateService(event: any): void {
		if (event.type === 'click') {
			const servicio: Servicio = event.row;
			this.buscadorServicioForm.get('servicio')?.patchValue(servicio);
			this.selectedService = servicio;

			if (this.serviceListModalRef) {
			this.serviceListModalRef.close();
			}
  		}
	}
}
